import React, { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { Input } from '../../../shared/Input';
import { formItems } from '../formItems';
import { InputHolder, InputHolderItem } from '../../../shared/InputHolder';
import { FormContext } from '../../../../store/refinance/RefinanceContext';
import { currencyToNumber, numberToCurrency } from '../../../../utils/formatting';
import { Select } from '../../../shared/Select';
import { getDefaultValue } from '../../../../utils/validations';
import { useStepper } from '../../../../utils';
import { parseSearchQuery, scrollToTopCalculator } from '../../../../utils/general';

export const Step1: FunctionComponent<{ id: number }> = ({id}) => {


	const {
		register,
		handleSubmit,
		formState: {errors, isValid},
	} = useForm({mode: 'onChange', defaultValues: {
		[formItems.step1.housePrice] : numberToCurrency(parseSearchQuery(window.location.search)[`rt-marktwaarde`] as unknown as number, true),
		}});

	const [completedText, setCompletedText] = useState('');
	const { updateForm, form } = useContext(FormContext);
	const {setStepTouched, setStepValid, setStepActive } = useStepper();
	const onSubmit = (data: any) => {
		data[formItems.step1.housePrice] = currencyToNumber(data[formItems.step1.housePrice]);
		data[formItems.step1.countMortgageParts] = parseInt(data[formItems.step1.countMortgageParts]);
		updateForm(data);
		setCompletedText(numberToCurrency(parseInt(data[formItems.step1.housePrice]), true));
		setStepTouched(2, false);
		setStepValid(2, false);
		setStepActive(2, false);
		setStepTouched(3, false);
		setStepValid(3, false);
		setStepActive(3, false);
		scrollToTopCalculator();
	};

	useEffect(() => {
		setTimeout(() => {
			scrollToTopCalculator(typeof parseSearchQuery(window.location.search)[`rt-marktwaarde`] !== 'undefined');
		}, 500)
		//scrollTo();
	}, [])

	return (
		<Fragment>
			<StepperHeader title="Huidige situatie" id={id} completedText={completedText}/>

			<StepperContent>
				<form onSubmit={handleSubmit(onSubmit)}>
					<InputHolder>
						<InputHolderItem isFullWidth={true}>
							<Input
								label="Geschatte huidige marktwaarde van de woning*"
								name={formItems.step1.housePrice}
								id={formItems.step1.housePrice}
								type="currency"
								hasError={errors[formItems.step1.housePrice]}
								placeholder="€"
								defaultValue={getDefaultValue(form, formItems.step1.housePrice)}
								register={register}
								validation={{required: true}}
							/>
							{errors[formItems.step1.housePrice] && (
								<span className="form__error">Vul hier de geschatte huidige marktwaarde van de woning in. Weet je deze niet? Bereken dan <a href={"https://www.hypotheker.nl/zelf-berekenen/wat-is-deze-woning-waard/"} target={"_blank"}>hier</a> je woningwaarde.</span>
							)}
						</InputHolderItem>
					</InputHolder>
					<InputHolder tooltip={formItems.step1.tooltips.countMortgageParts}>
						<InputHolderItem isFullWidth={true}>
							<Select
								label="Aantal hypotheekdelen*"
								name={formItems.step1.countMortgageParts}
								id={formItems.step1.countMortgageParts}
								register={register}
								value={getDefaultValue(form, formItems.step1.countMortgageParts)}
								validation={{ required: true }}
								options={[
									{
										name: '1 deel',
										value: 1,
									},
									{
										name: '2 delen',
										value: 2,
									},
									{
										name: '3 delen',
										value: 3,
									},
								]}
							/>
						</InputHolderItem>
					</InputHolder>
					<StepperSubmit id={id} isValidated={isValid}/>
				</form>
			</StepperContent>
		</Fragment>
	);
};
